/**
 * @generated SignedSource<<e0e169df1a5c9a2164d47810859f6b1b>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserLink_user",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserNameLabel_user"
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
};
node.hash = "81f9090b7ff903f387604acd3994fb63";
export default node;
